export default __webpack_public_path__ + "static/media/diy-hub.65ff753a.png";